// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".position-relative[data-v-c5d13eac]{position:relative}.password-toggle[data-v-c5d13eac]{position:absolute;top:50%;right:10px;transform:translateY(-50%);background:none;border:none;cursor:pointer}.password-toggle .fas[data-v-c5d13eac]{font-size:1.2em;color:#6c757d}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
